import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Loader2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import api, { errMsg, imageUrl } from "@/lib/api";

export default function ImagePicker({ imageId, setImageId }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/images", form);
      setImageId(data.id);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); ref.current.value = ""; }
  };

  return (
    <div className="flex items-center gap-3">
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="composer-image-input" />
      {imageId ? (
        <div className="relative">
          <img src={imageUrl(imageId)} alt="Lampiran" className="h-20 w-20 rounded-lg border border-border object-cover" data-testid="composer-image-preview" />
          <button type="button" onClick={() => setImageId(null)} className="absolute -right-2 -top-2 rounded-full bg-red-500 p-1 text-white" data-testid="composer-image-remove-btn"><X className="h-3 w-3" /></button>
        </div>
      ) : (
        <Button type="button" variant="secondary" size="sm" onClick={() => ref.current.click()} disabled={busy} data-testid="composer-image-upload-btn">
          {busy ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <ImagePlus className="mr-1.5 h-3.5 w-3.5" />} Lampir gambar
        </Button>
      )}
    </div>
  );
}
